module.exports = __webpack_public_path__ + "img/23-FCP-consider-your-next-steps.c1c5b078.svg";